import { lsegAnalyticsProxy, type ProductInsightEvent } from '@toggle/toggle';

import { apiFetch } from '~/utils/api-fetch/apiFetch';

export const postLsegAnalyticsEvent = (event: ProductInsightEvent) =>
  apiFetch<void>(lsegAnalyticsProxy.ingest.path, {
    body: { events: [event] },
    handleAuthErrors: false,
    method: 'post',
  });
